import React, { useEffect } from 'react';
import About from '@/components/About';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import Seo from '@/components/Seo';

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="App">
      <Seo
        title="Hakkımızda - Tilki Otomasyon"
        description="Tilki Otomasyon hakkında. Misyonumuz, vizyonumuz ve restoran otomasyon sektöründeki hedeflerimiz."
        path="/hakkimizda"
      />
      <Header />

      <main id="main-content">
        <h1 className="sr-only">Tilki Otomasyon Hakkında</h1>
        <About />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
